
import React, { useState } from 'react';






import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {
    Row,
  } from "reactstrap";


import question from '../../assets/img/question.svg'




const TrainingLoadProjectionHelp = (props) => {
  const {
    buttonLabel,
    className
  } = props;
  
  const [modal, setModal] = useState(false);
  

  const toggle = () => setModal(!modal);
  console.log(props.deviat)
  return (
    <div>
       <img alt="" onClick={toggle} src={question}  className="icons" style={{height:"20px",width:'20px',cursor:'pointer'}}/>
      <Modal isOpen={modal} toggle={toggle} className={className} style={{backgroundColor:'rgb(40,40,40)'}}>
        <ModalHeader toggle={toggle} style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>Training Load Projection</ModalHeader>
        <ModalBody style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <div class="form-group">
            <Row style={{padding:'10px'}}>     
               <p>The following training load chart is a prediction of your training load for the next month if you follow the apps training program</p>
               <p>The goal of leading pace's program is to keep your perceived stress in a stable negative value.</p>
               <p>The prediction is based on activities stress score. If you decide to not follow this program but replace the existing activities with activities that produce similar stress scores ( you can test different activities and see the outcomes in the input page ) your training load in the next month will be similar to the one below.</p>
            </Row>
          </div>
        </ModalBody>
        <ModalFooter style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <Button color="danger" onClick={toggle}>Close</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

function feedbackMessage(deviation){
    var message = "Need more Data. Train more and come back later for feedback"
    if (deviation<=0.1){
        message = 'Need more Data. Train more and come back later for feedback'
        return [message,'text-warning']
      }
    if (deviation<=1){
      message = 'Excellent work your training habits are very consistent.'
      return [message,'text-success']
    }
    if (deviation<=3){
        message = 'Your training habits consistent.'
        return [message,'text-info']
    }
    if (deviation<=5){
        message = 'Your training habits are not consistent. Consider following a more structured program. Injury risk is moderate'
        return [message,'text-warning']
    }
    if (deviation<=10){
        message = 'Unstructured training program.Your day to day training habits are extremely inconsistent. Injury risk is high'
        return [message,'text-danger']
    }
    if (deviation>10){
        message = 'Unstructured training program.Your day to day training habits are extremely inconsistent. Injury risk is critical high'
        return [message,'text-danger']
    }
    return [message,'text-warning']
}
export default TrainingLoadProjectionHelp;